export default __webpack_public_path__ + "static/media/8.45372a44.jpg";